import React from 'react';

const SuggestedInfluencers = () => {
  return (
    <div>
      
    </div>
  );
}

export default SuggestedInfluencers;
